import { GetApp } from "../../App"
import { PrintContentKind, PrintViewRequests, printableDays } from "./Context"
import { PrintLogbookViewProps } from "./Params"
import { PrintCruiseView } from "./CruiseView"
import { PrintDaysView } from "./DaysView"
import { PrintTripsView } from "./TripsView"

// Logbook print content: resolves the loaded print data + mode to the cruise,
// trips or days sub-view (or a "failed to load" message). Split out of PrintView
// so the shell stays content-agnostic and only picks logbook-vs-ship.
export function PrintLogbookView({ printMode, data }: PrintLogbookViewProps) {
  const app = GetApp();
  const t = app.getT("PrintView");

  const kind = PrintViewRequests.contentKind(printMode, data);
  switch (kind) {
    case PrintContentKind.cruise:
      return <PrintCruiseView cruise={data!.cruise!} />;
    case PrintContentKind.cruiseFailed:
      return <p>{t("failed_to_load_cruise")}</p>;
    case PrintContentKind.trips:
      return <PrintTripsView trips={data!.trips} />;
    case PrintContentKind.tripsFailed:
      return <p>{t("failed_to_load_trips")}</p>;
    case PrintContentKind.days:
      return <div>{printableDays(data!.days).map((d) => <PrintDaysView key={d.id} day={d} />)}</div>;
    case PrintContentKind.daysFailed:
      return <p>{t("failed_to_load_days")}</p>;
    default:
      return null;
  }
}
